import {
  Box,
  Checkbox,
  FormControl,
  FormLabel,
  HStack,
  Input,
  SimpleGrid,
  Text
} from '@chakra-ui/react'
import { useEffect, useMemo, useState } from 'react'
import { Controller } from 'react-hook-form'

function KidsKnowForm({
  role,
  control,
  errors,
  data,
  watchKnow,
  register,
  setValue,
}) {
  const knowOptions = [
    {
      id: 'doctor',
      label: 'แพทย์ / บุลคลากรทางการแพทย์',
      hasInput: true,
    },
    { id: 'lineOA', label: 'Line OA', hasInput: false },
    { id: 'friend', label: 'เพื่อน / ญาติ', hasInput: false },
    { id: 'youtube', label: 'YouTube', hasInput: false },
    { id: 'teacher', label: 'ครู / โรงเรียน', hasInput: true },
    { id: 'tiktok', label: 'TikTok', hasInput: false },
    { id: 'facebook', label: 'Facebook / Inbox', hasInput: false },
    { id: 'instagram', label: 'Instagram', hasInput: false },
    // { id: 'messenger', label: 'Messenger', hasInput: false },
    {
      id: 'advertising',
      label: 'ป้ายโฆษณา / ขับรถผ่าน / Walk in',
      hasInput: false,
    },
    { id: 'google', label: 'Google', hasInput: false },
    { id: 'other', label: 'อื่นๆ', hasInput: true },
    { id: 'website', label: 'Website', hasInput: false },
  ]

  // เก็บจำนวนที่เลือกไว้ใน state ภายใน
  const [selectedCount, setSelectedCount] = useState(0)

  // อัพเดทจำนวนที่เลือกเมื่อ watchKnow เปลี่ยน
  useEffect(() => {
    if (watchKnow && typeof watchKnow === 'object') {
      const count = Object.values(watchKnow).filter(
        (item) => item?.selected
      ).length
      setSelectedCount(count)
    }
  }, [watchKnow])

  // คำนวณว่าเลือกได้อีกหรือไม่
  const maxSelect = useMemo(() => {
    return selectedCount >= 2
  }, [selectedCount])

  return (
    <Box
      id='knowForm'
      borderWidth={errors?.know ? '1px' : '0px'}
      borderColor={errors?.know ? 'red.500' : 'transparent'}
      borderRadius='md'
      p={errors?.know ? 4 : 0}
    >
      <FormLabel my={3}>
        <HStack spacing={0}>
          <Text>
            ทราบข้อมูล KIDS PLUS จาก / KNOW KIDS PLUS FROM (เลือกได้มากสุด 2
            ข้อ)
          </Text>
          <Text color='red'>&nbsp;*</Text>
        </HStack>
      </FormLabel>

      <SimpleGrid
        columns={[1, 1, 2, 2]}
        spacingX={[1, 1, 1, '25px']}
        justifyContent='center'
        alignItems='center'
        spacing={6}
      >
        {knowOptions?.map((option, index) => (
          <FormControl
            key={index}
            isInvalid={errors?.know?.[option?.id]?.detail?.message}
          >
            <Text>{watchKnow?.[option?.id]?.selected}</Text>
            <HStack>
              <Controller
                name={`know.${option?.id}.selected`}
                id={`know.${option?.id}.selected`}
                control={control}
                defaultValue={
                  watchKnow?.[option?.id]?.selected ||
                  data?.know?.[option?.id]?.selected ||
                  false
                }
                render={({ field: { onChange, value } }) => (
                  <Checkbox
                    colorScheme='lime'
                    isChecked={value}
                    onChange={(e) => {
                      // อนุญาตให้ยกเลิกการเลือกได้ตลอดเวลา
                      if (value === true) {
                        onChange(false)
                        // ลดจำนวนที่เลือกทันที
                        setSelectedCount((prev) => Math.max(0, prev - 1))
                        if (
                          watchKnow?.[option?.id]?.detail &&
                          option?.hasInput
                        ) {
                          setValue(`know.${option?.id}.detail`, '')
                        }
                      } else {
                        // อนุญาตให้เลือกได้ถ้ายังไม่ถึง 2 ตัว
                        if (selectedCount < 2) {
                          onChange(true)
                          // เพิ่มจำนวนที่เลือกทันที
                          setSelectedCount((prev) => prev + 1)
                        }
                      }
                    }}
                    isDisabled={maxSelect && !value}
                  />
                )}
              />
              <Text>{option?.label}</Text>
              {option?.hasInput && (
                <Input
                  id={`know.${option?.id}.detail`}
                  {...register(`know.${option?.id}.detail`, {
                    required:
                      option?.hasInput && watchKnow?.[option?.id]?.selected
                        ? `This field is required`
                        : undefined,
                  })}
                  readOnly={!watchKnow?.[option?.id]?.selected}
                  errorBorderColor='red'
                  placeholder={
                    option?.hasInput &&
                    watchKnow?.[option?.id]?.selected &&
                    !watchKnow?.[option?.id]?.detail
                      ? 'โปรดระบุ'
                      : ''
                  }
                  w={'70%'}
                  name={`know.${option?.id}.detail`}
                  defaultValue={
                    watchKnow?.[option?.id]?.detail ||
                    data?.know?.[option?.id]?.detail ||
                    ''
                  }
                  isRequired={
                    option?.hasInput && watchKnow?.[option?.id]?.selected
                  }
                />
              )}
            </HStack>
          </FormControl>
        ))}
      </SimpleGrid>
    </Box>
  )
}

export default KidsKnowForm
